import request from '@/libs/functions/request'

// 等级数据
export function levelEquityList() {
  return request({
    uri: '/api/business/member/level/equityList',
    params: {},
    method: 'GET',
  })
}

// 等级数据
export function productPointList() {
  return request({
    uri: '/api/business/member/level/productPointList',
    params: {},
    method: 'GET',
  })
}

// 等级数据
export function getLevelProduct(params: { id: string }) {
  return request({
    uri: '/api/business/member/level/getLevelProduct',
    params,
    method: 'GET',
  })
}
